"use client"

import { atom } from 'jotai';
import { GridApiPro } from "@mui/x-data-grid-pro";
import { RefObject } from 'react';

export const dataGridApiAtom = atom<RefObject<GridApiPro | null> | null>(null);
